import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appListItem]',
})
export class ListItemDirective {
  public itemTemplate: TemplateRef<Element>;

  constructor(private readonly templateRef: TemplateRef<Element>) {
    this.itemTemplate = this.templateRef;
  }
}
